import type {Filter} from "../getFiltersFromMerchandisedPath"
import {NEW_URL_FACET_SEPARATOR} from "../../config/constants"

const sortFilters = (filters: Filter[]): Filter[] => {
    const filtersToBeSorted = [...filters]
    return filtersToBeSorted.sort(sortFunction)
}

export const sortFunction = (filter1: Filter, filter2: Filter): 1 | -1 | 0 => {
    if (filter1.filterName < filter2.filterName) {
        return -1
    }
    if (filter1.filterName > filter2.filterName) {
        return 1
    }
    if (filter1.filterName === filter2.filterName) {
        if (filter1.filterValue < filter2.filterValue) return -1
        if (filter1.filterValue > filter2.filterValue) return 1
    }
    return 0
}

export const getJoinedFilterPath = (filters: Filter[]): string => {
    const tempAccumulator = {
        path: "",
        tempFilterName: "",
    }

    const {path} = filters.reduce((acc, cur) => {
        if (acc.tempFilterName !== cur.filterName) {
            if (acc.tempFilterName === "")
                return {...acc, path: `${acc.path}${cur.filterName}-${cur.filterValue}`, tempFilterName: cur.filterName}
            return {...acc, path: `${acc.path}-${cur.filterName}-${cur.filterValue}`, tempFilterName: cur.filterName}
        }
        return {...acc, path: `${acc.path}${NEW_URL_FACET_SEPARATOR}${cur.filterValue}`}
    }, tempAccumulator)

    return path
}

export default sortFilters
